import validator from "validator";

const validEmail = (value: string) =>
  value && !validator.isEmail(value) && "Invalid E-mail";

export default validEmail;
